import { render, staticRenderFns } from "./TeamRace.vue?vue&type=template&id=6d00e952&"
import script from "./TeamRace.vue?vue&type=script&lang=js&"
export * from "./TeamRace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports